import { render, staticRenderFns } from "./AccessVersatility.vue?vue&type=template&id=29bcd994&scoped=true"
import script from "./AccessVersatility.vue?vue&type=script&lang=js"
export * from "./AccessVersatility.vue?vue&type=script&lang=js"
import style0 from "./AccessVersatility.vue?vue&type=style&index=0&id=29bcd994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bcd994",
  null
  
)

export default component.exports